/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { AuthProvider } from 'react-oidc-context';
import App from './App';
import reportWebVitals from './reportWebVitals';

const cognitoAuthConfig = {
    authority: 'https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_58J7pfqLD',
    client_id: '20d448r8f193ckd7pcfjua152k',
    redirect_uri: 'https://zengoku.ninja/callback',
    response_type: 'code',
    scope: 'email openid phone vocab-resource-server/vocab',
    onSigninCallback: () => {
        window.history.replaceState({}, document.title, '/');
    },
};

ReactDOM.render(
    <React.StrictMode>
        <AuthProvider {...cognitoAuthConfig}>
            <App />
        </AuthProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
